import styles from './RefinementListV2.module.scss';

type Context = 'filterBar' | 'allFilters';

/**
 * V2 classNames for Algolia's <RefinementList> widget (PLP filters redesign,
 * gated by FEATURE_FLAG_PLP_FILTERS_V2). Same slot shape as the legacy
 * refinementListClassNames but styled with design tokens to match Figma
 * (visible counts, custom checkbox, bordered search field).
 */
export const refinementListClassNamesV2 = (context?: Context) => {
  const showMoreClass = context
    ? `${styles.showMore} ${styles[`showMore--${context}`]}`
    : styles.showMore;

  return {
    root: styles.root,
    searchBox: styles.searchBox,
    noRefinementRoot: styles.noRefinementRoot,
    list: styles.list,
    noResults: styles.noResults,
    item: styles.item,
    label: styles.label,
    labelText: styles.labelText,
    count: styles.count,
    checkbox: styles.checkbox,
    showMore: showMoreClass,
    disabledShowMore: styles.disabledShowMore,
  };
};
